import { initApp } from "./app.js";

document.addEventListener("DOMContentLoaded", () => {
  initApp();
});
